<template>
    <div class="received-message-item">
        <v-avatar
            v-if="getDrSmassPersonas !== null"
            color="grey lighten-4"
            size="40"
        >
            <img :src="getDrSmassPersonas" alt="avatar">
        </v-avatar>
        <div class="question">
            <div v-if="currentQuestionData" class="float-right">
                <help-icon
                    v-if="currentQuestionData.description"
                    :id="((messageItemCode !== null) ? messageItemCode.prefix + 'HELP_' + messageItemCode.entityCode : null)"
                    class="float-right question-description-icon"
                    :svg-fill-class="'svg-block-background-color'"
                    @click.native="openQuestionDescriptionPopup(currentQuestionData)"
                >
                </help-icon>
                <question-description-popup
                    :questionData="questionForDescriptionPopup"
                    @onCloseQuestionDescPopup="closeQuestionDescriptionPopup()">
                </question-description-popup>
            </div>
            <message-received-content
                :id="((messageItemCode !== null) ? messageItemCode.prefix + 'TEXT_' + messageItemCode.entityCode : null)"
                @openDocPopup="openDocPopup"
                :msg-text="msgText"
            ></message-received-content>
        </div>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from "vuex";
    import HelpIcon from "../../../common/components/svg/shared/helpIcon";
    import QuestionDescriptionPopup from "../../../common/components/shared/QuestionDescriptionPopup";
    import MessageReceivedContent from "./MessageReceivedContent";

    export default {
        name: 'MessageReceived',
        components: {MessageReceivedContent, QuestionDescriptionPopup, HelpIcon},
        props: {
            msgText: {
                type: String,
                required: true
            },
            conversationMessage: {
                type: Object,
                required: false
            },
            questionData: {
                type: Object,
                required: false,
                default: null
            },
            isEdit: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                questionForDescriptionPopup: null,
                helpIconFillColor: '#efefef'
            }
        },
        computed: {
            ...mapGetters({
                getDrSmassPersonas: 'ChatBotStore/getDrSmassPersonas',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getCurrentGuiThemeColor: 'ThemeStore/getCurrentGuiThemeColor',
                getAssessmentStatuses: 'ChatBotStore/getAssessmentStatuses',
                getEntityTypes: 'ChatBotStore/getEntityTypes'
            }),

            currentQuestionData() {
                // Computed value to allow the message received to show the question description popup
                // using either the conversationMessage (in normal conversation)
                // or the questionData object (in edit answer popup)
                // if both are undefined return null
                if (this.conversationMessage) {
                    return this.conversationMessage;
                }
                if (this.questionData) {
                    return this.questionData;
                }

                return null;
            },

            messageItemCode () {

                if (!this.conversationMessage || !this.conversationMessage.entityType) {
                    return null;
                }

                if (this.conversationMessage.entityType === this.getEntityTypes.QUESTION) {
                    return {
                        entityCode: this.conversationMessage.questionCode,
                        prefix: "Q_" + (this.isEdit === true ? 'EDIT_' : '')
                    };
                }
                else {
                    return null;
                }
            }
        },
        mounted() {
            let colorTheme = this.getCurrentGuiThemeColor;
            let getLinkStartAssessment = document.querySelector('.received-message-item .question a');
            if(getLinkStartAssessment) {
                getLinkStartAssessment.style.setProperty("color", colorTheme, "important");
            }
        },

        methods: {

            openQuestionDescriptionPopup(question) {
                this.PfChatbotPlugin.hideScroll();
                this.questionForDescriptionPopup = question;
            },

            closeQuestionDescriptionPopup() {
                this.PfChatbotPlugin.showScroll();
                this.questionForDescriptionPopup = null;
            },

            openDocPopup(code) {
                this.$emit("openDocPopup", code)
            },
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/MessageReceived.vue